module.exports = __webpack_public_path__ + "static/media/sub_ourservices_banner.a21f4756.jpg";